module.exports = __webpack_public_path__ + "static/media/ai-voices.fadfe56a.svg";